<template>
  <v-container>
    <v-row>
      <v-col>
        <TablePicker
          title="Data Table"
          v-model="value.table"
          :required="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ColumnListEditor
          title="Exported Columns"
          :table="value.table"
          v-model="value.columns"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <FilterDesigner
          :table="value.table"
          title="Data Filter"
          v-model="value.filters"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TablePicker from "../shared/TablePicker.vue";
import ColumnListEditor from "../shared/ColumnListEditor.vue";
import FilterDesigner from "../shared/FilterDesigner.vue";

export default {
  name: "ExportDataDesigner",

  components: { TablePicker, ColumnListEditor, FilterDesigner },
 
  props: ["value", "containers", "table", "component"],
};
</script>
